import React from "react";
import PropTypes from "prop-types";

import { Button, Container, Header, Segment } from "semantic-ui-react";

function PricingUnavailable({ onUpgradeNow, loading, onRequestSupport }) {
  return (
    <Container>
      <Segment basic textAlign="center">
        <Header as="h2">Pricing Estimation Unavailable</Header>

        <div
          style={{ marginTop: "1em", lineHeight: "1.5" }}
          data-test="user-deactivation-message"
        >
          We&apos;re unable to calculate pricing for user deactivation at this
          time. No worries, though!
          <br />
          You can upgrade your plan now to see pricing details, or continue with
          the user deactivation process.
        </div>

        <div
          style={{
            display: "flex",
            gap: "10px",
            justifyContent: "center",
            marginTop: "1.5em",
          }}
        >
          <Button
            primary
            content="Upgrade Now"
            onClick={onUpgradeNow}
            disabled={loading}
          />
          <Button
            basic
            primary
            content="Deactivate User"
            onClick={onRequestSupport}
            disabled={loading}
            loading={loading}
          />
        </div>
      </Segment>
    </Container>
  );
}

PricingUnavailable.propTypes = {
  onUpgradeNow: PropTypes.func.isRequired,
  onRequestSupport: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

PricingUnavailable.defaultProps = {
  loading: false,
};

export default PricingUnavailable;
